// import 'bootstrap';
import { defineNuxtPlugin } from 'nuxt/app';

export default defineNuxtPlugin((nuxtApp) => {
    //
    // console.log(nuxtApp);
});
